import { ExamSummaryStat } from "@/components/exams/exam-summary/components/exam-summary-content";
import { CircleCheckBigIcon, CircleXIcon, PartyPopperIcon } from "lucide-react";

export const QuizSummaryContent = ({
  correct,
  incorrect,
  questionsCount,
}: {
  correct: number;
  incorrect: number;
  questionsCount: number;
}) => {
  return (
    <div className={"grid grid-cols-1 gap-6 md:grid-cols-3"}>
      <ExamSummaryStat
        title={"Poprawne odpowiedzi"}
        value={`${correct}`}
        icon={<CircleCheckBigIcon size={16} className={"stroke-teal-700"} />}
      />

      <ExamSummaryStat
        title={"Błędne odpowiedzi"}
        value={`${incorrect}`}
        icon={<CircleXIcon size={16} className={"stroke-red-700"} />}
      />

      <ExamSummaryStat
        title={"Liczba pytań"}
        value={`${questionsCount}`}
        icon={<PartyPopperIcon size={16} className={"stroke-remedium-blue"} />}
      />
    </div>
  );
};
